var exports = {
  "S": "linkItem__lwEGPw",
};

module.exports = exports;
